import { render, staticRenderFns } from "./VersionsTable.vue?vue&type=template&id=8681f528&scoped=true&"
import script from "./VersionsTable.vue?vue&type=script&lang=js&"
export * from "./VersionsTable.vue?vue&type=script&lang=js&"
import style0 from "./VersionsTable.vue?vue&type=style&index=0&id=8681f528&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8681f528",
  null
  
)

export default component.exports